import { render, staticRenderFns } from "./ProdutosPaginar.vue?vue&type=template&id=ca785e96&scoped=true&"
import script from "./ProdutosPaginar.vue?vue&type=script&lang=js&"
export * from "./ProdutosPaginar.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosPaginar.vue?vue&type=style&index=0&id=ca785e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca785e96",
  null
  
)

export default component.exports